import { createApp } from 'vue'
import Force from './Force.vue'
import './assets/global.css'

createApp(Force).mount('#force')
